// Mock data for Biofilia CoCreativa website

export const services = [
  {
    id: 1,
    name: 'Estrategia',
    description: 'Estrategias creativas que conectan tu marca con el mundo de manera sostenible.',
    icon: 'https://customer-assets.emergentagent.com/job_eco-creative-hub/artifacts/9ds44vey_Marketing.svg',
    fullDescription: 'Desarrollamos estrategias de marketing que no solo impulsan tu negocio o marca, sino que también promueven un mensaje de sostenibilidad. Conectamos tu marca con audiencias que valoran la responsabilidad ambiental y las emociones de alto valor, creando campañas que inspiran y generan un impacto positivo. Amamos ayudar a las empresas a prosperar en el mundo del marketing digital; alcanzando nuevas metas y dejar huella en este mundo de constante evolución.'
  },
  {
    id: 2,
    name: 'Marca',
    description: 'Construimos identidades de marca únicas que reflejan tus valores y visión.',
    icon: 'https://customer-assets.emergentagent.com/job_eco-creative-hub/artifacts/u45j3e3x_branding.svg',
    fullDescription: 'En nuestra agencia, creamos identidades que respiran sostenibilidad; construimos desde una marca, logotipos y sistemas visuales completos, tu branding reflejará el compromiso con el planeta y la sostenibilidad, utilizando principios de diseño ecológico para asegurar que tu marca no solo sea memorable, sino también responsable y de impacto en el mundo real.'
  },
  {
    id: 3,
    name: 'Diseño UX/UI',
    description: 'Experiencias digitales intuitivas que cautivan a tus usuarios.',
    icon: 'https://customer-assets.emergentagent.com/job_eco-creative-hub/artifacts/9a840u6q_Design_UX_UI.svg',
    fullDescription: 'Creamos sitios totalmente personalizados de acuerdo con las necesidades reales de tu negocio. Desde un sencillo landing page, tiendas en línea, hasta páginas corporativas con funcionalidades únicas, entregamos interfaces UI/UX y SEO con gran rendimiento y soluciones escalables; optimizando la eficiencia energética en el diseño digital.'
  },
  {
    id: 4,
    name: 'Impresión',
    description: 'Impresiones de alta calidad con materiales eco-amigables.',
    icon: 'https://customer-assets.emergentagent.com/job_eco-creative-hub/artifacts/7aixfn6j_Printing.svg',
    fullDescription: 'En colaboración creativa, con nuestra empresa hermana BioPrint, en la creación y oferta de soluciones innovadoras, sostenibles y de calidad para satisfacer las necesidades de comunicación impresa. Hoy es posible imprimir respetando el medio ambiente, eligiendo materiales sostenibles siempre que sea posible minimizando el impacto ambiental; con procesos de impresión offset que buscan la eficiencia y la reducción de residuos para tus materiales impresos.'
  },
  {
    id: 5,
    name: 'Empaque',
    description: 'Packaging sostenible que cuenta la historia de tu producto.',
    icon: 'https://customer-assets.emergentagent.com/job_eco-creative-hub/artifacts/wwnhnunb_Packing.svg',
    fullDescription: 'Creemos que el empaque es una extensión de tu marca y una oportunidad para la innovación sostenible. Diseñamos soluciones de empaque que minimizan el desperdicio, utilizan materiales biodegradables o reciclados, y ofrecen una experiencia de desempaque consciente y respetuosa con el medio ambiente.'
  },
  {
    id: 6,
    name: 'Producción Editorial',
    description: 'Libros y publicaciones diseñados con pasión y creatividad.',
    icon: 'https://customer-assets.emergentagent.com/job_eco-creative-hub/artifacts/3kycqgib_book%20making.svg',
    fullDescription: 'El servicio de edición e impresión de libros; inicia desde la recepción de su idea y textos, llevando su proceso desde corrección y edición de estilo, diseño y formación editorial, corrección ortotipográfica y lectura de pruebas; en el área de gráfica diseñamos: portada, contraportada y solapas, mockup y maquetación de libro, te acompañamos en la creación de libros bellos y responsables, promoviendo el uso de papeles reciclados y procesos de encuadernación sostenibles.'
  }
];

export const heroSlides = [
  {
    id: 1,
    image: 'https://customer-assets.emergentagent.com/job_eco-creative-hub/artifacts/h8nkkfej_Banner_inicio_01.png',
    title: '',
    subtitle: ''
  },
  {
    id: 2,
    image: 'https://customer-assets.emergentagent.com/job_eco-creative-hub/artifacts/5689kc2v_Banner_inicio_02.png',
    title: '',
    subtitle: ''
  },
  {
    id: 3,
    image: 'https://customer-assets.emergentagent.com/job_eco-creative-hub/artifacts/8n6e66wn_Banner_inicio_03.png',
    title: '',
    subtitle: ''
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: 'Snap-on México',
    category: 'Impresión',
    image: '/logos/Impresion-Snapon.jpg',
    description: 'Servicios de impresión y diseño de alta calidad',
    client: 'Omar Beltrán',
    position: 'Gerente de ventas Nacional'
  },
  {
    id: 2,
    title: 'Consegroup',
    category: 'Diseño UX/UI',
    image: '/logos/CONSEO.jpg',
    description: 'Rediseño de página web corporativa',
    client: 'Carol Griffi',
    position: 'CEO'
  },
  {
    id: 3,
    title: 'Ferretrade',
    category: 'Marca',
    image: '/logos/Brandingferretrade.png',
    description: 'Identidad de marca en nicho competitivo',
    client: 'Soledad Rivera',
    position: 'Fundadora'
  },
  {
    id: 4,
    title: 'Perlas de Sabiduría',
    category: 'Producción Editorial',
    image: '/logos/Libro.jpg',
    description: 'Edición y diseño editorial completo',
    client: 'Yehudit Farber',
    position: 'Autora'
  },
  {
    id: 5,
    title: 'Bahco',
    category: 'Empaque',
    image: '/logos/Bahco.jpg',
    description: 'Diseño de empaque para lanzamiento de producto',
    client: 'Ing. Luis A. Arroyo',
    position: 'Sales Manager'
  },
  {
    id: 6,
    title: 'EcoBranding México',
    category: 'Estrategia',
    image: '/logos/Ecobranding_ICON.jpg',
    description: 'Campaña digital de concienciación ambiental',
    client: 'Andrea Montoya',
    position: 'Directora de Marketing'
  }
];

export const companyValues = [
  {
    id: 1,
    title: 'Cocreatividad',
    description: 'Trabajamos conjuntamente con nuestros clientes para alcanzar resultados extraordinarios. La cocreación nos permite fusionar perspectivas y talentos para crear soluciones únicas e innovadoras.',
    icon: 'Sparkles'
  },
  {
    id: 2,
    title: 'Sostenibilidad',
    description: 'Cada proyecto es una oportunidad para cocrear un futuro más verde. Priorizamos materiales eco-amigables, procesos responsables y mensajes que inspiran el cuidado del planeta.',
    icon: 'Leaf'
  },
  {
    id: 3,
    title: 'Inclusión',
    description: 'Creemos en la diversidad como motor de creatividad. Diseñamos para todos, asegurando que cada voz sea escuchada y cada perspectiva sea valorada en nuestros proyectos.',
    icon: 'Users'
  },
  {
    id: 4,
    title: 'Honestidad',
    description: 'La transparencia es la base de nuestras relaciones. Comunicamos con claridad, cumplimos lo que prometemos y construimos confianza a largo plazo con cada cliente.',
    icon: 'Shield'
  }
];

export const companyInfo = {
  history: {
    title: 'Nuestra Historia',
    content: `Somos una agencia creativa y de medios publicitarios con casi 20 años de experiencia; enfocados en la conexión profunda entre las personas, la naturaleza y la creatividad. Amamos lo que hacemos, el lugar donde vivimos es por ello por lo que nos encaminamos a ser una organización 100% responsable con su entorno social y natural.

¡Únete! Se parte de las empresas que practican la sostenibilidad y recuperación del medio ambiente; transmite a tus clientes y al mundo que estas comprometido junto con nosotros por el planeta.`
  },
  mission: {
    title: 'Nuestra Misión',
    content: 'Crear comunicación visual y estrategias de marketing que generen impacto positivo, fusionando creatividad con responsabilidad ecológica. Nos comprometemos a ofrecer soluciones publicitarias sostenibles que conecten marcas con audiencias conscientes, promoviendo un mensaje de respeto al medio ambiente en cada proyecto que desarrollamos.'
  },
  vision: {
    title: 'Nuestra Visión',
    content: 'Ser el referente en la industria publicitaria mexicana como la agencia cocreativa líder en sostenibilidad. Aspiramos a transformar el sector, demostrando que la efectividad comercial y la responsabilidad ambiental van de la mano, inspirando a otras empresas a adoptar prácticas más conscientes y contribuyendo activamente a la regeneración del planeta.'
  }
};

export const testimonials = [
  {
    id: 1,
    name: 'Omar Beltrán',
    position: 'Gerente de ventas Nacional',
    company: 'Snap-on',
    service: 'Impresión',
    logo: '/logos/snap-on-industrial-logo-new-23.png',
    quote: 'Sus servicios de impresión y diseño que requerimos son de excelente calidad.'
  },
  {
    id: 2,
    name: 'Carol Griffi',
    position: 'CEO',
    company: 'Consegroup',
    service: 'Diseño UX/UI',
    logo: '/logos/Brand_CG.jpg',
    quote: 'Rediseñaron nuestra página web, captaron la idea y concepto que necesitaba.'
  },
  {
    id: 3,
    name: 'Soledad Rivera',
    position: 'Fundadora',
    company: 'Ferretrade',
    service: 'Marca',
    logo: '/logos/ICONO.svg',
    quote: 'Necesitábamos plasmar nuestra marca en un nicho competitivo.'
  },
  {
    id: 4,
    name: 'Yehudit Farber',
    position: 'Autora',
    company: 'Perlas de Sabiduría',
    service: 'Producción Editorial',
    logo: '/logos/Libro.jpg',
    quote: 'Felicitaciones, desarrollaron la edición y diseño del libro.'
  },
  {
    id: 5,
    name: 'Ing. Luis A. Arroyo',
    position: 'Sales Manager',
    company: 'SNA Europe',
    service: 'Empaque',
    logo: '/logos/imgi_3_SNAEuropeLogo.141d0db4.svg',
    quote: 'Su propuesta de empaque le dio valor a nuestra promoción de lanzamiento.'
  },
  {
    id: 6,
    name: 'Andrea Montoya',
    position: 'Directora de Marketing',
    company: 'EcoBranding México',
    service: 'Estrategia',
    logo: '/logos/Ecobranding_ICON.jpg',
    quote: 'La estrategia de marketing digital aumentó nuestra visibilidad significativamente.'
  }
];

export const valuePropositions = [
  {
    id: 1,
    title: 'Eficiencia Sostenible = Rentabilidad',
    description: 'Ahorro de costos y optimización de recursos en el uso de materiales y procesos de creación.',
    icon: 'https://customer-assets.emergentagent.com/job_eco-creative-hub/artifacts/5y34p9jf_1.png'
  },
  {
    id: 2,
    title: 'Blindaje de marca y lealtad del consumidor actual',
    description: 'Cualquiera que sea tu proyecto generaremos una lealtad superior a la de la competencia, permitiéndote destacar en mercados saturados y justificar un posicionamiento de mayor valor.',
    icon: 'https://customer-assets.emergentagent.com/job_eco-creative-hub/artifacts/p0db0rxj_2.png'
  },
  {
    id: 3,
    title: 'Soluciones "Todo en Uno"',
    description: 'Ahorro de tiempo y consistencia impecable. Olvídate de coordinar con múltiples proveedores que diluyen tu mensaje. En Biofilia Cocreativa unificamos desde la idea, la pasión y resultado final.',
    icon: 'https://customer-assets.emergentagent.com/job_eco-creative-hub/artifacts/9ldz6rva_3.png'
  }
];

export const clientLogos = [
  { id: 1, name: 'Snap-on', logo: '/logos/snap-on-industrial-logo-new-23.png' },
  { id: 2, name: 'SNA Europe', logo: '/logos/imgi_3_SNAEuropeLogo.141d0db4.svg' },
  { id: 3, name: 'Bahco', logo: '/logos/imgi_26_logo-bahco.png' },
  { id: 4, name: 'Eventifypro', logo: '/logos/logo_EP.png' },
  { id: 5, name: 'Ferretrade', logo: '/logos/logo-color.jpg' },
  { id: 6, name: 'Tortilleria Mazal', logo: '/logos/TORTILLERIA-MAZAL.png' },
  { id: 7, name: 'Flamingo Roft', logo: '/logos/Flamingo.png' },
  { id: 8, name: 'Consegroup', logo: '/logos/logo.svg' }
];

export const partnerLogos = [
  { id: 1, name: 'Adobe', logo: '/logos/descarga.png' },
  { id: 2, name: 'Affinity', logo: '/logos/Affinity_(App)_Logo.svg.png' },
  { id: 3, name: 'Google Partner', logo: '/logos/Google-Partner.png' },
  { id: 4, name: 'HubSpot', logo: '/logos/Hubspot-1024x300.png' },
  { id: 5, name: 'Meta', logo: '/logos/media_1e1d6ce6caa68dfd49689c46528c152d9fdeaad6f.jpg' },
  { id: 6, name: 'Stripe', logo: '/logos/Stripe_icon.png' },
  { id: 7, name: 'NFC', logo: '/logos/NFC.svg' },
  { id: 8, name: 'Mailchimp', logo: '/logos/mailchimp.svg' }
];

export const socialLinks = [
  { id: 'fb', label: '', icon: 'Facebook', url: 'https://www.facebook.com/BiofiliaCoCreativa/' },
  { id: 'ig', label: '', icon: 'Instagram', url: 'https://www.instagram.com/biofiliacocreativa/' },
  { id: 'wa', label: '', icon: 'MessageCircle', url: '#' },
  { id: 'ce', label: '', icon: 'Mail', url: '/contacta', internal: true }
];

export const footerLinks = {
  navigation: [
    { label: 'Nosotros', path: '/nosotros' },
    { label: 'Portafolio', path: '/portafolio' },
    { label: 'Servicios', path: '/servicios' }
  ],
  legal: [
    { label: 'Biotaping', path: 'https://www.biotaping.com', external: true },
    { label: 'BioPrint', path: '#' },
    { label: 'Política de privacidad', path: '/politica-privacidad' },
    { label: 'Términos de servicio', path: '/terminos-servicio' },
    { label: 'Configuración cookies', path: '/cookie-policy' }
  ]
};

export const contactFormFields = {
  services: [
    { id: 'marca', label: 'Marca' },
    { id: 'estrategia', label: 'Estrategia' },
    { id: 'empaque', label: 'Empaque' },
    { id: 'impresion', label: 'Impresión' },
    { id: 'uxui', label: 'Diseño UX/UI' },
    { id: 'editorial', label: 'Producción Editorial' },
    { id: 'otro', label: 'Otro' }
  ]
};

export const contactEmail = 'msalinas@biofilia.com.mx';
